import React, { useState, useEffect } from "react";
import { getAccessTokenApi } from "../../../api/auth";
import { get } from "../../../api/get";
import {  Select} from "antd";


import "./Inventory.scss";
import ListInventory from "./ListInventory/ListInventory.js";

export default function Inventory() {
  const { Option } = Select;
  const [itemsActive, setItemsActive] = useState([]); //Todos los usuarios
  const [hubsActive, setHubsActive] = useState([]); //Todos los usuarios
  const [itemsInactive, setItemsInactive] = useState([]);
  const [reloadItems, setReloadItems] = useState(false);

  const token = getAccessTokenApi();

  useEffect(() => {
    get(`items-active?active=${true}`,'items-active','').then((response) => {
    // getVehiclesActiveApi(token, true).then((response) => {
    //  console.log(response);
      setItemsActive(response.items);
    });

    get(`items-active?active=${false}`,'items-active','').then((response) => {
    // getVehiclesActiveApi(token, false).then((response) => {
      setItemsInactive(response.items);
    });

    get(`hubs-active?active=${true}`,'hubs-active','').then((response) => {
      //  console.log(response.hubs);
      var aux=[]
      for(var i=0;i<response.hubs.length;i++){
        aux.push(<Option value={response.hubs[i].name}>{response.hubs[i].name}</Option>)
      }
      
      setHubsActive(aux);
    });

    setReloadItems(false);
  }, [token, reloadItems]); //Solo se refresca si cambian estos

  return (
    <div className="items">
      <ListInventory
        itemsActive={itemsActive}
        hubsActive={hubsActive}
        itemsInactive={itemsInactive}
        setReloadItems={setReloadItems}
      />
    </div>
  );
}
